import React from "react";

// The kinds of breakage the hourly Haiku capture check (dww-api-2
// src/queue_check) names.
const ISSUES = {
  blank: "blank",
  partial_render: "partly rendered",
  missing_images: "missing images",
  missing_styles: "missing styles",
  error_page: "error page",
  bot_check: "bot check",
  wrong_page: "wrong page",
};

// Marks one screen of a run the capture check found "probably not a test": a
// capture that broke, not a test arm. `capture` is the check's answer for it
// (what broke and where); `sameAsWeight` is the weight of the screen it would
// look like once fixed. Sized in em so it follows the zoom level.
const BrokenCaptureBadge = ({ capture, sameAsWeight, className = "" }) => (
  <span
    className={`dib dark-gray bg-light-yellow fw6 br1 ${className}`}
    style={{
      fontSize: "0.8em",
      padding: "0 0.4em",
      lineHeight: 1.5,
    }}
    title={`Haiku capture check: ${capture.where}${
      sameAsWeight != null
        ? ` Once fixed it would look like the ${sameAsWeight}% screen.`
        : ""
    }`}
  >
    Broken: {ISSUES[capture.issue] || "other"}
  </span>
);

export default BrokenCaptureBadge;
